import { useQuery } from "@tanstack/react-query";
import { fetchInvoicesKPIs } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const useInvoicesKPIs = (
  params,
  { queryFn, queryKey, enabled, ...rest } = {}
) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false;
  return useQuery({
    queryKey: ["invoices", "kpis", params],
    queryFn: async () => {
      return await fetchInvoicesKPIs({ userId: id, params });
    },
    enabled: isEnabled,
    staleTime: 60 * 1000,
    ...rest,
  });
};
